export const notificationActionTypes = {
  SET_NOTIFICATION_COUNT: 'SET_NOTIFICATION_COUNT',
  SET_MESSAGE: 'SET_MESSAGE',
  SET_ROOMID: 'SET_ROOMID',
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  MARK_AS_READ: 'MARK_AS_READ',
  CLEAR_NOTIFICATION: 'CLEAR_NOTIFICATION',
  CLEAR_ALL: 'CLEAR_ALL',
  MARK_ALL_AS_READ: 'MARK_ALL_AS_READ',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
  SET_UNREAD_COUNT: 'SET_UNREAD_COUNT'
};

export const NOTIFICATION_TYPES = {
  NEW_MESSAGE: 'NEW_MESSAGE',
  NEW_CLIENT: 'NEW_CLIENT',
  FILE_RECEIVED: 'FILE_RECEIVED',
  TRANSFER: 'TRANSFER',
  SYSTEM: 'SYSTEM',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  COINS_EARNED: 'COINS_EARNED',
  CELEBRATION: 'CELEBRATION',
  FEEDBACK: 'FEEDBACK',
  SCHEDULED_MEETING: 'SCHEDULED_MEETING',
  COMMENT: 'COMMENT',
  // Novos tipos para estrutura ternária
  POST_MENTION: 'POST_MENTION',
  SYSTEM_ANNOUNCEMENT: 'SYSTEM_ANNOUNCEMENT',
  TEAM_NOTIFICATION: 'TEAM_NOTIFICATION',
  MAINTENANCE: 'MAINTENANCE',
  BROADCAST: 'BROADCAST',
  NEW_TICKET_ASSIGNED: 'NEW_TICKET_ASSIGNED',
  TICKET_UPDATED: 'TICKET_UPDATED',
  CHAT_CLOSED_BY_CLIENT: 'CHAT_CLOSED_BY_CLIENT',
  // Lembrete de compromisso da agenda (item 12).
  //
  // O valor é MINÚSCULO de propósito, ao contrário de todos os vizinhos: é a
  // string que a api grava (`DispatchCalendarReminders`: `'type' =>
  // 'calendar_reminder'`), e é por ela que os `switch` comparam. Era
  // justamente essa ausência que fazia o lembrete cair no `default` de todos
  // eles -- sem ícone, sem rótulo e com o clique sem efeito.
  CALENDAR_REMINDER: 'calendar_reminder'
};